var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mask Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.67199946,0 L10.3939029,0 C10.8464194,0 11.210474,0.35534284 11.210474,0.79703067 L11.210474,6.37624536 L14.1943606,6.37624536 C14.7999841,6.37624536 15.1027959,7.090252 14.6740961,7.5086931 L9.49907716,12.5631959 C9.24389871,12.812268 8.82540605,12.812268 8.5702276,12.5631959 L3.38840389,7.5086931 C2.9597041,7.090252 3.26251585,6.37624536 3.86813937,6.37624536 L6.85542842,6.37624536 L6.85542842,0.79703067 C6.85542842,0.35534284 7.21948301,0 7.67199946,0 Z M17,12.484375 L17,16.203125 C17,16.6447266 16.6447266,17 16.203125,17 L0.796875,17 C0.355273437,17 0,16.6447266 0,16.203125 L0,12.484375 C0,12.0427734 0.355273437,11.6875 0.796875,11.6875 L5.66777344,11.6875 L7.29472656,13.3144531 C7.96210937,13.9818359 9.03789062,13.9818359 9.70527344,13.3144531 L11.3322266,11.6875 L16.203125,11.6875 C16.6447266,11.6875 17,12.0427734 17,12.484375 Z M12.75,15.40625 C12.75,15.1140625 12.5109375,14.875 12.21875,14.875 C11.9265625,14.875 11.6875,15.1140625 11.6875,15.40625 C11.6875,15.6984375 11.9265625,15.9375 12.21875,15.9375 C12.5109375,15.9375 12.75,15.6984375 12.75,15.40625 Z M14.875,15.40625 C14.875,15.1140625 14.6359375,14.875 14.34375,14.875 C14.0515625,14.875 13.8125,15.1140625 13.8125,15.40625 C13.8125,15.6984375 14.0515625,15.9375 14.34375,15.9375 C14.6359375,15.9375 14.875,15.6984375 14.875,15.40625 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask-Copy-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy-2",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.29a119b8e546a7558ec733d1d7d7be3c.svg";
export { ForwardRef as ReactComponent };